import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import BASE_URL from "../constent";
import imageCompression from "browser-image-compression";

export const fetchAllCategory = createAsyncThunk(
  "categories/fetchAllCategory",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/category`);

      // console.log(response.data.data)
      return response.data.data;
    } catch (error) {
      if (error.response?.status === 404) {
        // The server returns 404 when there is no data
        return [];
      }

      return rejectWithValue(error.response?.data || "Failed to load requests");
    }
  }
);

export const AddCategory = createAsyncThunk(
  "categories/AddCategory",
  async ({ data }, { rejectWithValue }) => {
    try {
      // console.log(selectedSuperCategoryId)
      // console.log("🚀 Starting AddBrand function...");

      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const formData = new FormData();

      formData.append("title_en", data.nameEn);
      formData.append("title_ar", data.nameAr);
      formData.append("area", data.selectedAreaId);

      if (data.image instanceof File) {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1024,
          useWebWorker: true,
          fileType: "image/webp",
        };

        const compressedFile = await imageCompression(data.image, options);
        formData.append("image", compressedFile, `category-${Date.now()}.webp`);
      }

      // console.log("🧾 Sending Category with FormData...");

      const createResponse = await axios.post(
        `${BASE_URL}/category`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            token,
          },
        }
      );

      return createResponse.data.data;
    } catch (error) {
      console.error(
        " AddCategory failed:",
        error.message,
        error.response?.data
      );
      return rejectWithValue(error.response?.data || "Failed to add Category");
    }
  }
);

export const deleteCategoryById = createAsyncThunk(
  "categories/deleteCategoryById",
  async (id, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const response = await axios.delete(`${BASE_URL}/category/${id}`, {
        headers: {
          token: token,
        },
      });

      // console.log("✅ Category deleted:", response.data);

      // Can we return the id to update the state in the reducer?
      return id;
    } catch (error) {
      console.error("Delete failed:", error.message, error.response?.data);
      return rejectWithValue(
        error.response?.data || "Failed to delete Category"
      );
    }
  }
);

export const updateCategoryById = createAsyncThunk(
  "categories/updateCategoryById",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");
      const formData = new FormData();
      formData.append("title_en", data.nameEn);
      formData.append("title_ar", data.nameAr);
      formData.append("area", data.area);
      // formData.append("title", data.title);

      if (data.image instanceof File) {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1024,
          useWebWorker: true,
          fileType: "image/webp",
        };

        const compressedFile = await imageCompression(data.image, options);
        formData.append("image", compressedFile, `category-${Date.now()}.webp`);
      }

      const response = await axios.put(`${BASE_URL}/category/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          token: token,
        },
      });

      return response.data.updatedCategory || response.data;
    } catch (error) {
      console.error("Update failed:", error.message, error.response?.data);
      return rejectWithValue(
        error.response?.data || "Failed to update Category"
      );
    }
  }
);

export const fetchCategoryBySlug = createAsyncThunk(
  "categories/fetchCategoryBySlug",
  async (slug, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/category/${slug}`);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch category by slug"
      );
    }
  }
);

const categoriesSlice = createSlice({
  name: "categories",
  initialState: {
    allCategories: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.allCategories = action.payload;
      })
      .addCase(fetchAllCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export default categoriesSlice.reducer;

// Export actions and reducer
